import React from "react";
import { Breadcrumbs } from "web/react/components/breadcrumbs";
import { Divider } from "web/react/components/divider";
import { LystNewsArticleCard } from "web/react/components/lyst-news/lyst-news-article-card";
import { PaginatedContent } from "web/react/components/paginated-content/paginated-content";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { NewsArticleListSerializer } from "web/types/serializers";
import * as styles from "./lyst-news-index.css";

export function LystNewsIndex({ items, meta }: NewsArticleListSerializer): React.ReactElement {
    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "Lyst News", url: null },
    ];

    return (
        <PaginatedContent items={items} meta={meta} rothkoModule="modules/lyst_news">
            {(articles) => {
                const heroArticle = articles.length > 0 ? articles[0] : null;
                const restOfArticles = articles.length > 1 ? articles.slice(1) : [];

                return (
                    <div className={styles.container}>
                        <div className={styles.titleSectionContainer}>
                            <View
                                className={styles.titleSectionContent}
                                paddingBottom={{ lg: "lg", sm: "md" }}
                            >
                                <Breadcrumbs breadcrumbs={breadcrumbs} type="lyst_news" />
                                <Heading textStyle={{ lg: "hero-xl", sm: "title-1" }} as="h1">
                                    {gettext("lyst_news.top_header")}
                                </Heading>
                                <Text textStyle="body-s">
                                    {gettext("lyst_news.page_description")}
                                </Text>
                            </View>
                            <Divider />
                        </div>
                        <View paddingBottom="lg" width="full">
                            {heroArticle && (
                                <LystNewsArticleCard
                                    imgSrc={heroArticle.hero_image_url}
                                    title={heroArticle.title}
                                    subtitle={heroArticle.published_at as string}
                                    url={heroArticle.url}
                                    isHero
                                />
                            )}
                        </View>
                        <div className={styles.grid}>
                            {restOfArticles.map((storyCardProps, i) => (
                                <View marginBottom="lg" key={storyCardProps.title + i}>
                                    <LystNewsArticleCard
                                        imgSrc={storyCardProps.hero_image_url}
                                        title={storyCardProps.title}
                                        subtitle={storyCardProps.published_at as string}
                                        url={storyCardProps.url}
                                        lazy
                                    />
                                </View>
                            ))}
                        </div>
                    </div>
                );
            }}
        </PaginatedContent>
    );
}
